import { ZENDESK_URLS } from "../constants";

/**
 * Opens a Zendesk support ticket with pre-filled information
 * @param {Object} options - Configuration options
 * @param {string} options.language - Language code (e.g., 'en', 'ja', 'ko')
 * @param {string} options.userEmail - User's email address
 * @param {string} options.issueType - Type of issue (default: 'app_issues')
 * @param {string} options.subject - Subject line for the support ticket
 * @param {string} [options.description] - Description/details for the support ticket
 * @param {string} [options.txHash] - Transaction hash (will be added to description if provided)
 * @param {string} [options.recordId] - Record ID (e.g., stakeRecordId) to include in description
 */
export const openZendeskSupportTicket = ({
  language,
  userEmail,
  issueType = "app_issues",
  subject,
  description = "",
}) => {
  const searchParams = new URLSearchParams();
  searchParams.set("tf_42195543120665", issueType);
  searchParams.set("tf_subject", subject);
  searchParams.set("tf_anonymous_requester_email", userEmail);
  searchParams.set("tf_description", description);

  const helpUrl = ZENDESK_URLS[language.toUpperCase()]?.HELP;
  if (!helpUrl) {
    console.error(`No Zendesk URL found for language: ${language}`);
    return;
  }

  const url = `${helpUrl}/requests/new?${searchParams.toString()}`;
  window.open(url, "_blank", "noopener");
};

